import { Box } from '@mui/material';
import { baseTheme } from 'design-system';
import { JSX, useMemo } from 'react';

const IMAGE_SIZE = '64px';

export interface ImageUploadDefaultFieldProps {
  label?: string;
  justifyContent?: string;
  hasUploadFile?: boolean;
  onClick: () => void;
  renderFieldContent: (justifyContent?: string) => JSX.Element;
}

const ImageUploadDefaultField: React.FC<ImageUploadDefaultFieldProps> = ({
  label = '',
  justifyContent = 'space-between',
  hasUploadFile = false,
  onClick,
  renderFieldContent,
}) => {
  const boxStyles = useMemo(
    () => ({
      maxWidth: IMAGE_SIZE,
      width: IMAGE_SIZE,
      height: IMAGE_SIZE,
      border: hasUploadFile ? undefined : `2px dotted ${baseTheme.palette.grey[400]}`,
      borderRadius: baseTheme.spacing(1),
      backgroundColor: hasUploadFile ? undefined : baseTheme.palette.grey[100],
      cursor: 'pointer',
      '&:hover': hasUploadFile
        ? undefined
        : {
            backgroundColor: baseTheme.palette.grey[200],
          },
    }),
    [hasUploadFile],
  );

  return (
    <Box
      sx={boxStyles}
      onClick={onClick}
      aria-label={hasUploadFile ? `View uploaded ${label || 'files'}` : `Upload ${label || 'file'}`}
    >
      {renderFieldContent(justifyContent)}
    </Box>
  );
};

export default ImageUploadDefaultField;
